import { DataSeriesUnit } from "src/components/monitoring/commonTypes";
import { SxProps } from "@mui/material";

export const UNIT_MAP: { [key in DataSeriesUnit]: string } = {
    [DataSeriesUnit.PERCENT]: "% Ø",
    [DataSeriesUnit.WATT]: " W",
    [DataSeriesUnit.WH]: " Wh",
    [DataSeriesUnit.KILOWATT]: " kW",
    [DataSeriesUnit.KWH]: " kWh",
    [DataSeriesUnit.KVA]: " kVA",
    [DataSeriesUnit.VAH]: " VAh",
    [DataSeriesUnit.VOLT]: " V",
    [DataSeriesUnit.AMPERE]: " A",
    [DataSeriesUnit.CELSIUS]: " °C",
    [DataSeriesUnit.TIME]: " ",
    [DataSeriesUnit.STATE]: "",
};

export const formatDataSeriesUnitToString = (unit: DataSeriesUnit): string => {
    return UNIT_MAP[unit] || UNIT_MAP[DataSeriesUnit.KWH];
};

export const unstyledButtonStyle: SxProps = {
    minWidth: 0,
    padding: 0,
    backgroundColor: "unset",
    color: "unset",
    textAlign: "inherit",
    borderRadius: 8,
    transition: "unset",
    "&:hover": {
        backgroundColor: "unset",
    },
};
